var Handlebars = require('/src/melia-widget/node_modules/handlebars/runtime.js');
module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.escapeExpression, alias2=depth0 != null ? depth0 : (container.nullContext || {});

  return "        <div data-categoryId=\""
    + alias1(container.lambda((depth0 != null ? depth0.catId : depth0), depth0))
    + "\" class=\"melia-categories-container\">\n            <div class=\"melia-categories-panel-icon-container\">\n"
    + ((stack1 = helpers["if"].call(alias2,(depth0 != null ? depth0.imagePath : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.program(4, data, 0),"data":data})) != null ? stack1 : "")
    + "            </div>\n            <div class=\"melia-categories-panel-text\">"
    + alias1((helpers.t || (depth0 && depth0.t) || helpers.helperMissing).call(alias2,(depth0 != null ? depth0.name : depth0),{"name":"t","hash":{},"data":data}))
    + "</div>\n        </div>\n";
},"2":function(container,depth0,helpers,partials,data) {
    return "                    <img src=\""
    + container.escapeExpression(container.lambda((depth0 != null ? depth0.imagePath : depth0), depth0))
    + "\" class=\"melia-categories-panel-image\">\n";
},"4":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.iconClass : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "");
},"5":function(container,depth0,helpers,partials,data) {
    return "                        <i class=\"melia-categories-panel-icon "
    + container.escapeExpression(container.lambda((depth0 != null ? depth0.iconClass : depth0), depth0))
    + "\"></i>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "<div class=\"melia-categories-panel\">\n"
    + ((stack1 = helpers.each.call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.categories : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "</div>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/components/categoriesPanel/categoriesPanel.hbs
// module id = 178
// module chunks = 1